<template>
    <div class="">
        <Alert type="warning" show-icon closable v-if="noChanges" @on-close="noChanges=false">Nothing to update</Alert>
        <Form ref="hardwareModuleForm" :model="hardwareModuleForm" :rules="hardwareModuleRules" v-show="hardwareModuleForm._id" style="margin-bottom: 24px;">
            <FormItem prop="ModuleName">
                <i-input
                        v-model="hardwareModuleForm.ModuleName"
                        type="text"
                        placeholder="H/W module name"
                ></i-input>
            </FormItem>
            <FormItem prop="HardwareVersion" label="H/W version: ">
                <InputNumber :min="1" v-model="hardwareModuleForm.HardwareVersion"></InputNumber>
            </FormItem>
            <FormItem prop="HardwareDescription">
                <Input v-model="hardwareModuleForm.Description" type="textarea" placeholder="Description" :autosize="{minRows: 5,maxRows: 5}" />
            </FormItem>
        </Form>
        <Row justify="center">
            <i-col :xs="{span:12,offset:12}" v-if="showUpdate">
                <Button long
                        type="success"
                        :loading="submitUpdateLoading"
                        @click="handleUpdate()"
                >       <span v-if="!submitUpdateLoading">Update h/w Module</span>
                    <span v-else>Processing...</span>
                </Button>
            </i-col>
        </Row>
        <Spin size="large" fix v-if="spinShow">
            <Icon type="ios-loading" size=32 class="spin-icon-load"></Icon>
        </Spin>
    </div>

</template>

<script>
    import { getHardware, updateHardware } from "../../_services/firmware.service";
    import { bus } from "../../main";

    export default {
        props:['hardwareModules'],
        data() {
            const validateName = (rule, value, callback) => {
                let duplicateName=this.hardwareModules.filter(({ModuleName})=>{
                    return ModuleName===value
                })
                if(duplicateName.length){
                    if(this.hardwareModuleForm._id){
                        if(duplicateName.length>1){
                            callback(new Error('H/W module name already exist.'));
                        }else{
                            if(duplicateName[0]._id!==this.hardwareModuleForm._id){
                                callback(new Error('H/W module name already exist.'));
                            }else{
                                callback();
                            }
                        }
                    }else{
                        callback(new Error('H/W module name already exist.'));
                    }
                }else{
                    callback();
                }

                // if (value === 'V1') {
                //     if(this.currentUpdateData.ModuleName==='V1'){
                //         callback();
                //     }else {
                //         if(duplicateName.length){
                //             callback(new Error('H/W module name already exist.'));
                //         }else {
                //             callback();
                //         }
                //     }
                // } else {
                //
                //     if(duplicateName.length){
                //         if(this.hardwareModuleForm._id){
                //             if(duplicateName.length>1){
                //                 callback(new Error('H/W module name already exist.'));
                //             }else{
                //                 if(duplicateName[0]._id!==this.hardwareModuleForm._id){
                //                     callback(new Error('H/W module name already exist.'));
                //                 }else{
                //                     callback();
                //                 }
                //             }
                //         }else{
                //             callback(new Error('H/W module name already exist.'));
                //         }
                //     }else{
                //         callback();
                //     }
                // }
            };

            const validateVersion = (rule, value, callback) => {
                let duplicateVersion=this.hardwareModules.reduce((duplicates,hardware)=>{
                   if(hardware.ModuleName===this.hardwareModuleForm.ModuleName &&
                       hardware.HardwareVersion===this.hardwareModuleForm.HardwareVersion &&
                        hardware._id!==this.hardwareModuleForm._id){
                       duplicates.push(hardware)
                   }
                   return duplicates
                },[])
                if(duplicateVersion.length){
                    callback(new Error('H/W version already exist.'));
                }else{
                    callback();
                }
            };
            return {
                submitUpdateLoading:false,
                submitLoading:false,
                showUpdate:false,
                noChanges:false,
                hardwareModuleForm: {
                    _id:null,
                    ModuleName: "",
                    HardwareVersion:1,
                    Description:""
                },
                currentUpdateData:{
                    _id:null,
                    ModuleName: "",
                    HardwareVersion:1,
                    Description:""
                },
                hardwareModuleRules: {
                    ModuleName: [
                        {required: true, message: 'Module name can not be empty', trigger: 'blur'},
                    ],
                    HardwareVersion: [
                        { validator: validateVersion, trigger: 'blur' }
                    ]
                },
                spinShow:false,
            };
        },
        methods: {
            setUpdateData(data){
                let vm=this
                vm.noChanges=false
                vm.spinShow=true
                if(this.currentUpdateData._id){
                    vm.spinShow=false
                    if(JSON.stringify(this.currentUpdateData)!==JSON.stringify(this.hardwareModuleForm)){
                        this.$Modal.confirm({
                            title: 'Unsaved Changes',
                            content: `Changes made on ${this.currentUpdateData.ModuleName} is not yet saved? Do you wish to save it first?`,
                            okText: 'Save',
                            cancelText: 'Discard',
                            onOk:() => {
                                this.handleUpdate(data)
                            },
                            onCancel: () =>{
                                this.getHardwareModuleData(data)
                                this.$emit('setActive',data)
                            }
                        });
                    }else{
                        this.getHardwareModuleData(data)
                        this.$emit('setActive',data)
                    }
                }else {
                    this.getHardwareModuleData(data)
                    this.$emit('setActive',data)
                }
            },
            getHardwareModuleData(data){
                let vm=this
                getHardware(data._id).then(res=>{
                    vm.resetForm()
                    this.showUpdate=true
                    vm.hardwareModuleForm=res.data.data.hardware
                    this.currentUpdateData = Object.assign({},res.data.data.hardware)
                    bus.$emit('hardwareChanged',Object.assign({},res.data.data));
                    vm.spinShow=false
                }).catch(err=>{
                    bus.$emit('requestError',err)
                    vm.spinShow=false
                    this.$Message.error("Failed to get Firmwares. Please try again later.");
                })
            },

            resetForm(){
                this.showUpdate=false
                this.currentUpdateData={
                    _id:null,
                    ModuleName: "",
                    HardwareVersion:1,
                    Description:""
                }
                this.hardwareModuleForm={
                    _id:null,
                    ModuleName: "",
                    HardwareVersion:1,
                    Description:""
                }
                if(this.$refs.hardwareModuleForm) {
                    this.$refs.hardwareModuleForm.resetFields();
                }
            },
            handleUpdate(nexData) {
                if(JSON.stringify(this.currentUpdateData)!==JSON.stringify(this.hardwareModuleForm)) {
                    this.noChanges=false
                    this.$refs.hardwareModuleForm.validate(valid => {
                        if (valid) {
                            this.submitUpdateLoading = true
                            this.hardwareModuleForm.NewModuleName = this.hardwareModuleForm.ModuleName
                            updateHardware(this.hardwareModuleForm._id, this.hardwareModuleForm).then(res => {
                                this.$Message.success(`Successfully updated ${this.hardwareModuleForm.ModuleName}!`);
                                this.$emit('getHardwareModules')
                                this.$emit('setActive',null)
                                bus.$emit('hardwareChanged', null)
                                this.submitUpdateLoading = false
                                this.currentUpdateData = Object.assign({}, res.data.data)
                                if (nexData) {
                                    this.$emit('setActive',nexData)
                                    this.getHardwareModuleData(nexData)
                                }
                                this.resetForm()
                            }).catch(err => {
                                bus.$emit('requestError', err)
                                this.submitUpdateLoading = false
                                this.$emit('getHardwareModules')
                                this.$emit('setActive',null)
                                // this.$Message.error('Failed to update hardware. Please try again later.')
                                this.$Message.error(err.response.data.message)
                            })
                        }
                    });
                }else{
                    this.noChanges=true
                }
            },
        },
        mounted() {
        }
    };
</script>
<style scoped>

</style>
